import { Exporter, downloadCSV } from "react-admin";
import jsonExport from "jsonexport/dist";
import { formatEquipmentLabel } from "../../utils/formatEquipment";

export const makeRemovalsBySiteExporter =
  (siteInternalCode: string): Exporter =>
  async (records, fetchRelatedRecords /*, dataProvider */) => {
    const equipmentsById = await fetchRelatedRecords(
      records,
      "equipment",
      "equipments"
    );

    const rows = records.map((r: any) => {
      const eq = equipmentsById[r.equipment];
      const counts = r.counts || {};

      return {
        id: r.id ?? r._id,
        siteInternalCode,
        equipment: formatEquipmentLabel(eq),
        counts_0: counts._0 ?? 0,
        counts_25: counts._25 ?? 0,
        counts_50: counts._50 ?? 0,
        counts_75: counts._75 ?? 0,
        counts_100: counts._100 ?? 0,
        counts_125: counts._125 ?? 0,
        equivalentFullUnits: r.equivalentFullUnits ?? 0,
        tonnage: r.tonnage ?? 0,
        quantityAtTheMoment: r.quantityAtTheMoment ?? "",
        note: r.note ?? "",
        scheduledAt: r.scheduledAt ? new Date(r.scheduledAt).toISOString() : "",
        createdAt: r.createdAt ? new Date(r.createdAt).toISOString() : "",
      };
    });

    jsonExport(
      rows,
      {
        headers: [
          "id",
          "siteInternalCode",
          "equipment",
          "counts_0",
          "counts_25",
          "counts_50",
          "counts_75",
          "counts_100",
          "counts_125",
          "equivalentFullUnits",
          "tonnage",
          "quantityAtTheMoment",
          "note",
          "datePlan",
          "createdAt",
        ],
      },
      (err: any, csv: any) => {
        if (err) {
          console.error(err);
          return;
        }
        downloadCSV(csv, `removals_${siteInternalCode}.csv`);
      }
    );
  };
